import { ref } from 'vue'

export default function () {
  const questions = ref([
    {
      title: '01.請問貴公司是否為上市櫃公司?',
      value: null,
      name: 'question1',
      col: {
        xs: 12,
        md: 4,
      },
      options: [
        {
          label: '上市公司，資本額>50億元',
          value: 100,
        },
        {
          label: '上市公司，資本額20-50億元',
          value: 200,
        },
        {
          label: '上市公司，資本額<20億元',
          value: 300,
        },
        {
          label: '上櫃公司/興櫃公司',
          value: 300,
        },
        {
          label: '非上市公司',
          value: 500,
        },
      ],
    },
    {
      title: '02.請問貴公司屬於哪一個產業類別?',
      value: null,
      name: 'question2',
      col: {
        xs: 12,
        md: 6,
      },
      options: [
        {
          label: '電子業/電子零組件/電機電子設備等',
          value: 0,
        },
        {
          label: '化工業/材料業/原物料',
          value: 1,
        },
        {
          label: '食品/民生消費品',
          value: 1,
        },
        {
          label: '金融業/保險業/銀行業',
          value: 1,
        },
        {
          label: '其他',
          value: 0,
        },
      ],
    },
    {
      title: '03.請問貴公司是否設立台灣生產基地?',
      value: null,
      name: 'question3',
      col: {
        xs: 12,
        md: 6,
      },
      options: [
        {
          label: '在台灣有生產基地，並已取得空水廢相關許可證',
          value: 1,
        },
        {
          label: '在台灣沒有生產基地，只有倉庫與組裝',
          value: 0,
        },
        {
          label: '在台灣沒有生產基地，性質為貿易公司或服務業',
          value: 0,
        },
      ],
    },
    {
      title: '04.請問貴公司是否進行外銷出口業務?',
      value: null,
      name: 'question4',
      col: {
        xs: 12,
        md: 6,
      },
      options: [
        {
          label: '是，從台灣直接出口到國外(含歐美)',
          value: 1,
        },
        {
          label: '是，從台灣直接出口到國外(不含歐美)',
          value: 0,
        },
        {
          label: '是，從台灣以外工廠出口到客戶端',
          value: 0,
        },
        {
          label: '否，不從事外銷出口業務',
          value: 0,
        },
      ],
    },
    {
      title: '05.請問貴公司是否進行溫室氣體盤查?',
      value: null,
      name: 'question5',
      col: {
        xs: 12,
        md: 12,
      },
      options: [
        {
          label: '公司已經執行溫盤(ISO14064-1 2018版本)並取得第三方查證證書',
          value: 0,
        },
        {
          label: '公司已經執行溫盤(ISO14064-1 2018版本)但尚未取得第三方查證',
          value: 1,
        },
        {
          label: '公司以用電量計算出範疇二溫室氣體排放量',
          value: 1,
        },
        {
          label: '公司尚未執行溫室氣體盤查作業',
          value: 10,
        },
      ],
    },
    {
      title: '06.是否有客戶要求貴公司提供碳排放或碳足跡相關資料?',
      value: null,
      name: 'question6',
      col: {
        xs: 12,
        md: 6,
      },
      options: [
        {
          label: '是，已有客戶要求我方提供碳排放資料',
          value: 1,
        },
        {
          label: '是，已有客戶要求我方提供碳排放及碳足跡資料 ',
          value: 10,
        },
        {
          label: '尚未有客戶要求',
          value: 0,
        },
      ],
    },
    {
      title: '07.請問貴公司是否響應國際人權政策?',
      value: null,
      name: 'question7',
      col: {
        xs: 12,
        md: 6,
      },
      options: [
        {
          label: '本公司已經有人權宣言與人權議題政策',
          value: 0,
        },
        {
          label: '本公司尚未有人權宣言與人權議題政策',
          value: 1,
        },
      ],
    },
    {
      title: '08.CSR/ESG執行程度?',
      value: null,
      name: 'question8',
      col: {
        xs: 12,
        md: 12,
      },
      options: [
        {
          label:
            '已經出版ESG/CSR報告書超過5年，並積極設定重大議題管理方針(如碳管理)',
          value: 0,
        },
        {
          label: '已經出版ESG/CSR報告書，但尚未進行各項重要議題的行動 ',
          value: 1,
        },
        {
          label: '已經開始內部準備ESG/CSR資料收集，但尚未出版ESG/CSR報告書',
          value: 10,
        },
        {
          label: '目前沒有聽聞ESG永續發展議題',
          value: 100,
        },
      ],
    },
    {
      title: '09.請問公司是否已有氣候變遷相關風險管理辦法? ',
      value: null,
      name: 'question9',
      col: {
        xs: 12,
        md: 4,
      },
      options: [
        {
          label: '是，已經有專責人員負責',
          value: 0,
        },
        {
          label: '是，尚未有專責人員負責',
          value: 1,
        },
        {
          label: '否，尚未制定此類辦法',
          value: 1,
        },
      ],
    },
  ])

  return {
    questions,
  }
}
